import { createSlice } from '@reduxjs/toolkit';

const dataMappings = createSlice({
  name: 'DATA_MAPPINGS',
  initialState: {}, // a required field, but overwritten by preloadedState in store
  reducers: {
    setComponentIdToSagaStatus(state, action) {
      const { payload } = action;
      const { componentId, status } = payload;
      return {
        ...state,
        componentIdToSagaStatus: {
          ...state.componentIdToSagaStatus,
          [componentId]: status,
        },
      };
    },
  },
});

const { actions, reducer } = dataMappings;

export const { setComponentIdToSagaStatus } = actions;

export default reducer;
